function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { BOS, HALIFAX, LLOYDS, LLOYDS2023, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 24v-4.834L11.123 12 21 4.834V0L4 11.954z",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "17.4134808 21.9992673 15.9992673 23.4134808 4.58554219 11.9997558 15.9992673 0.586030688 17.4134808 2.00024425 7.41426725 11.9992443"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 20l-8-7.879L20 4l-4-4L4 12.121 16 24z",
    fillRule: "evenodd"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.4677 23.5757L5 12.0073L16.4677 0.43888C17.0478 -0.146293 17.9849 -0.146293 18.5649 0.43888C19.145 1.02405 19.145 1.96934 18.5649 2.55451L9.2093 11.9923L18.5649 21.4301C19.145 22.0153 19.145 22.9605 18.5649 23.5457C17.9785 24.1373 17.0722 24.155 16.4677 23.5757Z",
    fill: "currentColor"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 11.9985L16.5557 -6.31316e-08L18 1.5L7.89001 12L18 22.5L16.5557 24L5 11.9985Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.001111, 12.000000) rotate(-180.000000) translate(-12.001111, -12.000000) ",
    d: "M14.6954442,11.9966749 L6.06549781,20.9677835 C5.41446098,21.6445573 5.4078682,22.7770827 6.07703517,23.4727034 C6.74949853,24.1734641 7.82412134,24.1734641 8.48669554,23.4864102 L18.1368744,13.4547371 C18.5060699,13.069233 18.667593,12.538094 18.616499,12.0223752 C18.6857231,11.4946629 18.5258483,10.9429638 18.1368744,10.5403262 L8.48669554,0.508653036 C7.83565871,-0.168120813 6.74620214,-0.174974219 6.07703517,0.520646496 C5.40292362,1.21969391 5.40292362,2.3367991 6.06549781,3.02556641 L14.6954442,11.9966749 Z"
  }));
};
MbnaIcon.defaultProps = {
  fill: "currentColor",
  fillRule: "evenodd",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5677 23.5645C17.9913 24.1452 17.0568 24.1452 16.4804 23.5645L5 12L16.4804 0.435471C17.0568 -0.145157 17.9913 -0.145157 18.5677 0.435471C19.1441 1.0161 19.1441 1.95748 18.5677 2.53811L9.17468 12L18.5677 21.4619C19.1441 22.0425 19.1441 22.9839 18.5677 23.5645Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import React from 'react';
import { ThemeContext } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = React.useContext(ThemeContext) || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.chevron_left) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.chevron_left;
  } else {
    switch (brand) {
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}